export default "__VITE_ASSET__BZ6nNPN6__"